import AppDownloadBadges from "@/components/common/AppDownloadBadges";

const AppButton = () => <AppDownloadBadges style={{ flexDirection: "column", alignItems: "flex-start" }} />;

export default AppButton;
